export const AccessDeniedPage = () => {
  return <div>Access Forbidden</div>;
};
